export default "__VITE_ASSET__DXxxaFqP__"